import { Type } from "class-transformer";
import { Absence } from "./absences";
import { Duty } from "./duties";
import { Employment } from "./employments";
import { AbstractJSONModel } from "./master-model";
import { Pool } from "./pools";

export interface IWorkHourPoolStatus {
  work_hour_pools: Pool[];
  absences: Absence[];
  employments: Employment[];
  pool_duties: Duty[];
}

export class WorkHourPoolStatus extends AbstractJSONModel implements IWorkHourPoolStatus {
  @Type(() => Pool)
  work_hour_pools: Pool[] = [];
  @Type(() => Absence)
  absences: Absence[] = [];
  @Type(() => Employment)
  employments: Employment[] = [];
  @Type(() => Duty)
  pool_duties: Duty[] = [];
}
